import React from "react";
import InputFactory from "../InputFactory";

export default function CustomFilterGenerator({
  schema,
  onChangeFilter,
  justify = "end",
}) {
  const formattedFilters = () => {
    return schema.filters.map((filter) => {
      const field = schema.fields[filter];
      return {
        ...field,
        fieldName: filter,
        placeholder: `Search ${field.label}`,
      };
    });
  };

  return (
    <div
      className={`row d-flex justify-content-${justify}`}
      style={{ width: "100%" }}
    >
      {formattedFilters().map((field) => {
        const { type, fieldName, ...options } = field;
        return (
          <div
            className="col-4 position-relative d-flex align-items-center"
            key={field}
          >
            {type === "String" ? (
              <i
                class="bi bi-search position-absolute"
                style={{ right: "1.5rem", zIndex: 2 }}
              ></i>
            ) : null}
            <InputFactory
              type={type}
              field={fieldName}
              onChange={(value, field) => onChangeFilter(type, value, field)}
              style={{ paddingRight: type === "String" ? "2.2rem" : "" }}
              className="col-4"
              {...options}
            />
          </div>
        );
      })}
    </div>
  );
}
